export default Object.freeze({
  IS_ALL_LOADED: 'isAllLoaded',
  MENU_EVENT_BUS: 'menuEventBus',
  OMNI_SEARCH_EVENT_BUS: 'omniSearchEventBus',
  SHOW_MENU: 'showMenu',
  LAST_UNAUTHORIZED_PATH: 'lastUnauthorizedPath',
  HAS_UNAUTHORIZED_LOGIN_ATTEMPT: 'hasUnauthorizedLoginAttempt',
  IS_SIGNED_IN: 'isSignedIn',
  IS_GRANTED: 'isGranted',
  JWT: 'jwt',
  USER_NAME: 'userName',
  USER_FIRST_NAME: 'userFirstName',
  USER_ID: 'userId',
  PACKAGE_NAME: 'packageName',
  ORGANIZER_NAME: 'organizerName',
  ORGANIZER_ID: 'organizerId',
  ORGANIZATION_NUMBER: 'organizationNumber',
  DEFAULT_REPURCHASE: 'defaultRepurchase',
  VAT_NUMBER: 'vatNumber',
  EMAIL: 'email',
  PHONE_NUMBER: 'phoneNumber',
  AUTHORITY: 'authority',
  MODULE_CATEGORIES: 'moduleCategories',
  ARE_MODULES_ALREADY_LOADED: 'areModulesAlreadyLoaded',
  IS_BASIC_INFO_ALREADY_LOADED: 'isBasicInfoAlreadyLoaded',
  MODULE_CATEGORIES_WITH_GRANTED_MODULES: 'moduleCategoriesWithGrantedModules',
  SUB_MODULES: 'subModules',
  GRANTED_SUB_MODULES: 'grantedSubModules',
  SETTINGS_MODULE: 'settingsModule',
  BREADCRUMBS: 'breadcrumbs',
  BASE64_AVATAR: 'base64Avatar',
  CACHED_EVENTS: 'cachedEvents',
  ACTIVE_AND_DRAFT_CACHED_EVENTS: 'activeAndDraftCachedEvents',
  EVENT_UNDER_EDIT: 'eventUnderEdit',
  EVENT_UNDER_EDIT_ID: 'eventUnderEditId',
  SHOW_UNDER_EDIT: 'showUnderEdit',
  SHOW_UNDER_EDIT_ID: 'showUnderEditId',
  MASTER_ARENAS: 'masterArenas',
  EVENT_CATEGORIES: 'eventCategories',
  PRICING_CATEGORIES: 'pricingCategories',
  THEME: 'theme',
});
